import { render, staticRenderFns } from "./PDFthumbnail.vue?vue&type=template&id=22987971&scoped=true"
import script from "./PDFthumbnail.vue?vue&type=script&lang=js"
export * from "./PDFthumbnail.vue?vue&type=script&lang=js"
import style0 from "./PDFthumbnail.vue?vue&type=style&index=0&id=22987971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22987971",
  null
  
)

export default component.exports